import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const PendingOrders = () => {
  return (
    <>
      <OrderTable status={1} isActive="pending" />
    </>
  );
};

export default PendingOrders;
